<template class="comment-sheet-importer">
  <div>
    <v-dialog
      v-model="dialog"
      width="70vw"
      height="80vh"
    >
      <v-card>
        <v-card-actions
          class="comment-sheet-importer__close-button"
        >
          <DsButton
            v-tooltip="closeLabel"
            #top-right
            color="tertiary"
            name="close"
            :icon="true"
            @click="dialog = false"
          />
        </v-card-actions>
        <v-card-text class="comment-sheet-importer__modal-style">
          <h3>{{ this.$t('components.CommentSheetImporter.faq.title') }}</h3>
          <p>{{ this.$t('components.CommentSheetImporter.faq.description') }}</p>

          <h3>{{ this.$t('components.CommentSheetImporter.faq2.title') }}</h3>
          <p>{{ this.$t('components.CommentSheetImporter.faq2.description') }}</p>

          <h3>{{ this.$t('components.CommentSheetImporter.faq3.title') }}</h3>
          <p>{{ this.$t('components.CommentSheetImporter.faq3.description') }}</p>

          <h3>{{ this.$t('components.CommentSheetImporter.faq4.title') }}</h3>
          <p>{{ this.$t('components.CommentSheetImporter.faq4.description') }}</p>
        </v-card-text>
      </v-card>
    </v-dialog>

    <GenericChart
      :request-status="requestStatus"
      :title="title"
      :open-dialog="openDialog"
      :item-id="itemId"
      :has-filter="false"
      :has-data-to-export="false"
      v-bind="$attrs"
    />
    <v-form
      ref="form"
      v-model="valid"
    >
      <v-row>
        <v-col>
          <template>
            <v-file-input
              v-model="file"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              :disabled="isSending"
              :rules="rules.isValue"
              :placeholder="$t('components.CommentSheetImporter.label.insertFile')"
              :label="$t('components.CommentSheetImporter.label.file')"
              prepend-icon="mdi-paperclip"
              required
            >
              <template v-slot:selection="{ text }">
                <v-chip
                  small
                  label
                  color="primary"
                >
                  {{ text }}
                </v-chip>
              </template>
            </v-file-input>
          </template>
        </v-col>
      </v-row>
    </v-form>
    <v-row
      no-gutters
      justify="end"
    >
      <DsButton
        :disabled="disableButton"
        :loading="isSending"
        color="primary"
        rounded
        large
        @click="postData"
      >
        {{ $t('components.CommentSheetImporter.label.send') }}
      </DsButton>
      <DsButton
        :disabled="isSending"
        color="secondary"
        class="ml-3"
        rounded
        large
        @click="resetForm"
      >
        {{ $t('components.CommentSheetImporter.label.clear') }}
      </DsButton>
    </v-row>
    <v-card v-if="success">
      <v-card-text class="comment-sheet-importer__card-content">
        <v-list-item class="card-content__item">
          <div>
            <span
              class="font-weight-bold"
            >
              {{ $t('components.CommentSheetImporter.label.status') }}
            </span>
            {{ translateStatus(rawResponse.status) }}
          </div>
        </v-list-item>
        <v-list-item>
          <div>
            <span
              class="font-weight-bold"
            >
              {{ $t('components.CommentSheetImporter.label.totalPosts') }}
            </span>
            {{ rawResponse.totalPosts }}
          </div>
        </v-list-item>
        <v-list-item>
          <div>
            <a
              :href="rawResponse.dataStorageUrl"
              target="_blank"
              class="font-weight-bold"
            >
              {{ $t('components.CommentSheetImporter.exportLinkText') }}
            </a>
          </div>
        </v-list-item>
      </v-card-text>
    </v-card>
    <v-card v-if="error && errorMessage">
      <v-card-text class="comment-sheet-importer__card-content">
        <v-list-item>
          <div>
            <span
              class="font-weight-bold"
            >
              {{ $t('components.CommentSheetImporter.label.errorMessage') }}
            </span>
            {{ errorMessage.description }}
          </div>
        </v-list-item>
        <v-list-item v-if="errorMessage.data">
          <div>
            <a
              :href="errorMessage.data"
              target="_blank"
              class="font-weight-bold"
            >
              {{ $t('components.CommentSheetImporter.exportLinkText') }}
            </a>
          </div>
        </v-list-item>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { DsButton } from '@ds/components';
import cardsModel from '@/mixins/cards-model';
import GenericChart from '@/components/cards/models/GenericChart';
import SheetImporterService from '@/services/SheetImporterService';

export default {
  name: 'CommentSheetImporter',
  components: {
    DsButton,
    GenericChart,
  },
  mixins: {
    cardsModel,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      file: null,
      dialog: false,
      requestStatus: 'success',
      isSending: false,
      valid: true,
      modal: false,
      token: null,
      rawResponse: null,
      success: false,
      error: false,
      errorMessage: null,
    };
  },
  computed: {
    rules() {
      return {
        isValue: [v => Boolean(v) || this.$t('components.CommentSheetImporter.label.requiredValue')],
      };
    },
    infoLabel() {
      return this.$t('components.CommentSheetImporter.infoLabel');
    },
    closeLabel() {
      return this.$t('components.CommentSheetImporter.closeLabel');
    },
    statusItems() {
      return {
        queued: {
          text: this.$t('components.CommentSheetImporter.label.queued'),
          value: 'QUEUED',
        },
      };
    },
    ...mapState('user', [
      'user',
    ]),
    ...mapState('filter', [
      'accountId',
      'universeId',
    ]),
    ...mapState('dashboard', [
      'isStaging',
      'apiToken',
    ]),
    disableButton() {
      return this.isSending || !this.file;
    },
  },
  methods: {
    ...mapActions('cards', [
      'getSheetImporterService',
    ]),
    translateStatus(status) {
      return status === this.statusItems.queued.value
        ? this.$t('components.CommentSheetImporter.label.queued')
        : this.$t('components.CommentSheetImporter.label.proccessed');
    },
    openDialog() {
      this.dialog = true;
    },
    createFormData() {
      const formData = new FormData();
      formData.append('file', this.file);
      return formData;
    },
    createQueryStrings() {
      const options = new URLSearchParams();
      options.append('accountId', this.accountId);
      options.append('universeId', this.universeId);
      options.append('token', this.apiToken);
      return options;
    },
    resetForm() {
      this.$refs.form.reset();
      this.file = null;
      this.success = false;
      this.error = false;
      this.clearResponses();
    },
    clearResponses() {
      this.rawResponse = null;
      this.errorMessage = null;
    },
    clearForm() {
      this.$refs.form.reset();
      this.file = null;
    },
    async postData() {
      this.isSending = true;
      this.clearResponses();
      const formData = this.createFormData();
      const queryStrings = this.createQueryStrings();
      try {
        const response = await SheetImporterService.commentSheetImporter(formData, queryStrings);
        this.success = true;
        this.clearForm();
        this.$noty.success(this.$t('components.CommentSheetImporter.upload.success'));
        this.rawResponse = response;
      } catch (e) {
        console.error(e);
        this.error = true;
        this.errorMessage = e.response.data;
        this.$noty.error(this.$t('components.CommentSheetImporter.upload.error'));
      } finally {
        this.isSending = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .comment-sheet-importer {
    overflow: hidden;

    &__close-button {
      display: flex;
      flex: end;
      justify-content: flex-end;
    }

    &__card-content {
      padding: 1rem 0 0 0;
      display: flex;
      flex-direction: column;
      font-size: var(--ds-font-size-xs);
      line-height: 16px;
      overflow: hidden;

      .v-list-item {
        min-height: 2rem;
      }
    }

    &__modal-style {
      * {
        color: var(--ds-color-snow) !important;
      }
    }
  }

  ::v-deep {
    .v-input {
      display: flex;
    }
  }
</style>
